import { stickFaq } from "./stick"
import { faqFormInit } from "./form"
import { route } from "./route"
import { formAdmin } from "./reply"
import { questionInit } from "./question"

export const faqInit = () => {
  stickFaq()
  faqFormInit()
  route()
  formAdmin()
  questionInit()
}
